import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import { IconButton, Tooltip } from "@mui/material";
import { $getSelection } from "lexical";
import { useCallback } from "react";
import { $isDesignHuddleNode } from "../../nodes/design-huddle-node";
import { $isImageNode } from "../../nodes/image-node";
import { $isVideoNode } from "../../nodes/video-node";
import { RESIZE_END_COMMAND } from "../../types/commands";
import { floatingToolbarStyles } from "./floating-toolbar-styles";

import type { ToolbarProps } from "./props";
import type { FC } from "react";

export const ImageFullWidthButton: FC<
  ToolbarProps & {
    active?: boolean;
  }
> = ({ disabled, mode, active }) => {
  const [editor] = useLexicalComposerContext();

  const onClick = useCallback(() => {
    editor.getEditorState().read(() => {
      const selection = $getSelection();
      const node = selection?.getNodes()[0];
      if ($isImageNode(node) || $isDesignHuddleNode(node) || $isVideoNode(node)) {
        editor.dispatchCommand(RESIZE_END_COMMAND, {
          nodeKey: node.getKey(),
          proportionOfMaxWidth: 1,
        });
      }
    });
  }, [editor]);

  return (
    <Tooltip title="Expand to paper width">
      <IconButton
        data-analytics-id={`lexical-${mode}-image-full-width`}
        disabled={disabled}
        data-testid={`${mode}-button-image-full-width`}
        data-active={active}
        aria-label="Expand to paper width"
        aria-pressed={active}
        tabIndex={-1}
        sx={{
          ...floatingToolbarStyles[mode].button,
          backgroundColor: active ? "background.active" : "background.neutral",
        }}
        onClick={onClick}
      >
        <OpenInFullIcon sx={floatingToolbarStyles[mode].formatIcon} />
      </IconButton>
    </Tooltip>
  );
};
